export const chuyenHang = {
  sections: {
    list: { title: 'Chuyển hàng' },
    detail: { title: 'Chi tiết phiếu chuyển' },
  },
  titles: { add: 'Tạo phiếu chuyển hàng' },
  columns: {
    code: 'Mã phiếu',
    summary: 'Thông tin',
    status: 'Trạng thái',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    branchFrom: 'Chi nhánh chuyển',
    branchTo: 'Chi nhánh nhận',
    createdAt: 'Ngày tạo',
    transferValue: 'Giá trị chuyển',
    transferDate: 'Ngày chuyển',
    receivedDate: 'Ngày nhận',
    totalQty: 'Tổng SL',
    totalReceivedQty: 'SL nhận',
    receivedValue: 'Giá trị nhận',
    receiveNote: 'Ghi chú nhận',
    phieuKho: 'Phiếu kho',
    maPhieuXuatKho: 'Phiếu xuất kho',
    maPhieuNhapKho: 'Phiếu nhập kho',
  },
  filter: {
    searchPlaceholder: 'Tìm theo mã phiếu...',
    title: 'Lọc',
    trangThai: 'Trạng thái',
    chiNhanhDi: 'Chi nhánh chuyển',
    chiNhanhDen: 'Chi nhánh nhận',
    tuNgay: 'Từ ngày',
    denNgay: 'Đến ngày',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    dateRangePlaceholder: 'Chọn khoảng ngày',
    all: 'Tất cả',
    reset: 'Đặt lại',
    sortDir: 'Thứ tự',
    asc: 'Tăng dần',
    desc: 'Giảm dần',
    maHangHoa: 'Mã sản phẩm',
    tenHangHoa: 'Tên sản phẩm',
  },
  placeholders: {
    toolbarSearch: 'Theo mã phiếu',
  },
  filters: {
    hintSection: 'Gợi ý',
    hintBody: 'Dùng ô tìm kiếm để lọc nhanh.',
  },
  form: {
    code: 'Mã phiếu',
    codeAuto: 'Để trống tự sinh mã',
    branchFrom: 'Chi nhánh chuyển',
    branchTo: 'Chi nhánh nhận',
    note: 'Ghi chú',
    lines: 'Hàng chuyển',
    addLine: 'Thêm dòng trống',
    product: 'Hàng hóa',
    productSearch: 'Tìm mã / tên hàng',
    qty: 'SL chuyển',
    qtyReceived: 'Số lượng nhận',
    unitPrice: 'Giá chuyển',
    donGiaMua: 'Giá chuyển',
    giaChuyen: 'Giá chuyển',
    donViTinhMua: 'ĐVT',
    dvt: 'ĐVT',
    maSp: 'Mã hàng',
    tenSp: 'Tên hàng',
    maHang: 'Mã hàng',
    tenHang: 'Tên hàng',
    stt: 'STT',
    tonKho: 'Tồn kho',
    tonKhoNhan: 'Tồn kho nhận',
    hinhThucVc: 'Hình thức VC',
    cont: 'Cont',
    maVanChuyenNcc: 'Mã vận chuyển NCC',
    maVanChuyenAzl: 'Mã vận chuyển AZL',
    maYcmh: 'Mã YCMH',
    maBaoGia: 'Mã báo giá',
    giamGia: 'Giảm giá',
    serialImei: 'Serial/IMEI',
    dateSanPham: 'Date sản phẩm',
    lineAmount: 'Thành tiền',
    discount: 'Giảm giá',
    discountPercent: 'Giảm (%)',
    lineNote: 'Ghi chú',
    createdAt: 'Ngày tạo',
    transferDate: 'Ngày chuyển',
    receivedDate: 'Ngày nhận',
    totalQty: 'Tổng số lượng',
    totalReceivedQty: 'Tổng SL nhận',
    receivedValue: 'Giá trị nhận',
    receiveNote: 'Ghi chú nhận',
    sectionHeader: 'Thông tin chung',
    sectionLines: 'Hàng hóa chuyển',
    tongSoMatHang: 'Số mặt hàng',
    tongSoLuong: 'Tổng số lượng',
    tongTienHang: 'Tổng tiền hàng',
    lineCount: '{count} dòng',
    save: 'Lưu',
  },
  fields: {
    code: 'Mã phiếu',
    ngayChuyen: 'Ngày chuyển',
    ngayXuatKho: 'Thời gian xuất kho',
    ngayNhapKho: 'Thời gian nhập kho',
    transferValue: 'Giá trị chuyển',
  },
  detailTabs: {
    chung: 'Chung',
    generalInfo: 'Thông tin',
    chiTietHang: 'Chi tiết hàng',
    flow: 'Flow chuyển hàng',
    lines: 'Hàng chuyển',
  },
  status: {
    phieuTam: 'Phiếu tạm',
    choXuat: 'Chờ xuất kho',
    dangChuyen: 'Đang chuyển',
    daNhan: 'Đã nhận',
    daHuy: 'Đã hủy',
    cho: 'Chờ xác nhận',
    daHoanThanh: 'Hoàn thành',
  },
  messages: {
    loadError: 'Không tải được danh sách.',
    deleteSuccess: 'Đã xóa phiếu chuyển.',
    huySuccess: 'Đã hủy phiếu chuyển.',
    confirmHuy:
      'Hủy phiếu {name}? Phiếu xuất kho và phiếu nhập kho liên quan (nếu có) cũng bị hủy: chi nhánh chuyển được hoàn tồn, chi nhánh nhận bị trừ lại phần đã nhận.',
    createSuccess: 'Đã tạo phiếu chuyển hàng.',
    updateSuccess: 'Đã cập nhật phiếu chuyển.',
    needLines: 'Vui lòng thêm ít nhất một dòng hàng.',
    needChiNhanhDen: 'Chọn chi nhánh nhận trước khi lưu.',
    needMaSp: 'Nhập mã SP cho mọi dòng hàng.',
    needTenSp: 'Nhập tên SP cho mọi dòng hàng.',
    needSoLuong: 'Nhập số lượng sản phẩm (> 0) cho mọi dòng.',
    needDonViTinhMua: 'Nhập đơn vị tính mua cho mọi dòng hàng.',
    needMaLo: 'Nhập Serial/IMEI cho hàng {code}.',
    needHanSuDung: 'Nhập date sản phẩm cho hàng {code}.',
    warnOverStock: 'Cảnh báo vượt tồn CN xuất: {detail}',
    noData: 'Không có phiếu chuyển.',
    importDescription:
      'Chọn chi nhánh nhận, tải file mẫu (mã hàng / SL chuyển / giá / giảm giá). Một file tạo một phiếu tạm. Có thể nhập trực tiếp hoặc xem trước để chỉnh sửa.',
    importSuccess: 'Đã nhập hàng hóa từ Excel.',
    importWillCreate: 'Sẽ tạo 1 phiếu chuyển hàng từ {count} dòng hàng.',
    importPreviewProgress: 'Xem trước phiếu chuyển',
    importPreviewLoading: 'Đang chuẩn bị phiếu chuyển…',
    importPreviewDone: 'Đã tạo phiếu chuyển từ xem trước.',
    noLines: 'Không có dòng hàng.',
    listSummary: 'Tổng {count} phiếu',
    confirmDelete: 'Xóa phiếu {name}?',
    completeSuccess: 'Đã chuyển trạng thái sang đang chuyển.',
    batDauChuyenSuccess:
      'Đã tạo và hoàn thành phiếu xuất kho (trừ tồn chi nhánh chuyển). Phiếu chuyển sang Đang chuyển.',
    hoanThanhXuatSuccess:
      'Đã hoàn thành phiếu xuất (trừ tồn chi nhánh chuyển). Phiếu chuyển sang Đang chuyển.',
    receiveSuccess: 'Đã tạo phiếu nhập kho (cộng tồn chi nhánh nhận). Phiếu chuyển sang Đã nhận.',
    confirmComplete: 'Chốt phiếu chuyển sang trạng thái đang chuyển? Không thể sửa sau khi chốt.',
    confirmBatDauChuyen: 'Xác nhận chuyển phiếu {code}?',
    confirmBatDauChuyenWarn: 'Sau bước này không sửa được danh sách hàng',
    confirmBatDauChuyenHint1: 'Tạo và hoàn thành phiếu xuất kho: trừ tồn chi nhánh chuyển ngay.',
    confirmBatDauChuyenHint2: 'Phiếu chuyển sang trạng thái Đang chuyển.',
    confirmBatDauChuyenHint3:
      'Bước tiếp theo: chi nhánh nhận bấm "Xác nhận nhận hàng" để tạo phiếu nhập kho và cộng tồn.',
    confirmHoanThanhXuat: 'Hoàn thành xuất kho cho phiếu {code}?',
    confirmHoanThanhXuatWarn: 'Thao tác này sẽ trừ tồn chi nhánh chuyển',
    confirmHoanThanhXuatHint1: 'Hoàn thành phiếu xuất {maPhieu}: trừ tồn chi nhánh chuyển.',
    confirmHoanThanhXuatHint1NoCode: 'Hoàn thành phiếu xuất kho: trừ tồn chi nhánh chuyển.',
    confirmHoanThanhXuatHint2: 'Phiếu nhập kho được tạo khi chi nhánh nhận xác nhận nhận hàng.',
    confirmHoanThanhXuatHint3: 'Phiếu chuyển sang trạng thái Đang chuyển.',
    confirmReceive: 'Xác nhận nhận hàng phiếu {code}?',
    confirmReceiveWarn: 'Thao tác này sẽ tạo phiếu nhập kho và cộng tồn',
    confirmReceiveHint1: 'Hoàn thành phiếu nhập {maPhieu}: cộng tồn chi nhánh nhận.',
    confirmReceiveHint1NoCode:
      'Tạo và hoàn thành phiếu nhập kho: cộng tồn chi nhánh nhận theo số thực nhận, giá vốn theo phiếu xuất chuyển.',
    confirmReceiveHint2: 'Phiếu chuyển sang trạng thái Đã nhận. Không hoàn tác được.',
    needNgayXuatKho: 'Chọn thời gian xuất kho.',
    needNgayChuyen: 'Chọn ngày chuyển trước khi lưu.',
    ngayNhanMustAfterXuat: 'Thời gian nhập phải sau thời gian xuất chuyển.',
  },
  actions: {
    complete: 'Hoàn thành chuyển',
    batDauChuyen: 'Xác nhận chuyển',
    huyPhieu: 'Hủy phiếu',
    hoanThanhXuat: 'Hoàn thành xuất kho',
    confirmReceive: 'Xác nhận nhận hàng',
    copy: 'Sao chép',
    addLine: 'Thêm dòng trống',
    importExcel: 'Nhập Excel',
    downloadTemplate: 'Tải file mẫu',
    dongY: 'Đồng ý',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
    xuatKho: 'Phiếu xuất kho chuyển hàng',
    nhapKho: 'Phiếu nhập kho chuyển hàng',
    empty: 'Chưa tạo phiếu',
    viewPhieuXuat: 'Xem phiếu xuất {maPhieu}',
    viewPhieuNhap: 'Xem phiếu nhập {maPhieu}',
    phieuCho: 'Đang chờ xác nhận',
    phieuHoanThanh: 'Đã hoàn thành',
    phieuHuy: 'Đã hủy',
  },
  theoDoi: {
    title: 'Theo dõi chuyển hàng',
    tabs: {
      theoDoi: 'Theo dõi',
      viecCuaToi: 'Việc của tôi',
      doiChieu: 'Đối chiếu',
    },
    steps: {
      tao: 'Phiếu tạm',
      choXuat: 'Chờ xuất kho',
      xuat: 'Xuất kho',
      dangChuyen: 'Đang chuyển',
      nhap: 'Nhập kho',
      hoanThanh: 'Đã nhận',
      daNhan: 'Đã nhận',
    },
    searchPlaceholder: 'Tìm mã phiếu, chi nhánh...',
    selectPrompt: 'Chọn một phiếu chuyển để xem chi tiết.',
    openDetail: 'Mở phiếu',
    totalQty: 'Tổng SL',
    receiveNotePlaceholder: 'Ghi chú nhận (tùy chọn)',
    noPending: 'Không có phiếu nào đang chờ xác nhận.',
    xuatKho: 'Phiếu xuất',
    nhapKho: 'Phiếu nhập',
    col: {
      hangHoa: 'Hàng hóa',
      slChuyen: 'SL chuyển',
      slXuat: 'SL xuất',
      slNhan: 'SL nhận',
      chenhLech: 'Chênh lệch',
    },
  },
}
